import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Yay my blog is up and running again! :D",
  "description": "",
  "published": "2010-03-29T00:00:00.000Z",
  "redirect_from": ["/blog/yay-my-blog-is-up-and-running-again-d/swizec/1266"],
  "categories": "life, Nginx, PHP, Server, Uncategorized, Web server",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://www.flickr.com/photos/22641075@N03/2583922605"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2010/03/2583922605_d074c280da_m.jpg",
              "alt": "Carlton Banks",
              "title": "Carlton Banks"
            }}></img></a></p>
        <p parentName="li">{`Image by `}<a parentName="p" {...{
            "href": "http://www.flickr.com/photos/22641075@N03/2583922605"
          }}>{`jimmagz`}</a>{` via Flickr`}</p>
      </li>
    </ul>
    <p>{`Now this is the story all about how My blog got flipped, turned upside down And I'd like to take a minute just sit right there I'll tell you how I fucked it all up so damn well`}</p>
    <p>{`In West Apache born and raised On the playground where it spent most of his days Chilling out, maxing, relaxing all cool And all serving some blabber outside of the school When a couple of admins said 'we're up in no good' Started making trouble in my neighbourhood I forgot one little date and my blog got scared And said 'you're moving with your aunt and uncle in nginx'`}</p>
    <p>{`I begged and pleaded with them the other day But they packed my suitcase and sent me on my way They gave me a kissin' and they gave me my ticket I put my walkman on and said I might as well kick it`}</p>
    <p>{`First class, yo this is bad, Drinking errors juice out of a config glass Is this what the people of nginx livin' like, Hmm this might be alright!`}</p>
    <p>{`I whistled for a cab and when it came near the Licensplate said 'Fresh' and had a dice in the mirror If anything I could say that this cab was rare But I thought now forget it, yo home to nginx`}</p>
    <p>{`I pulled up to a house about seven or eight And I yelled to the cabby 'Yo, home smell you later' Looked at my kingdom I was finally there To settle my throne as the prince of Bel-Air`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/07d6515b-ed71-417a-b3ee-2bc76a13aaa3/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=07d6515b-ed71-417a-b3ee-2bc76a13aaa3",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      